import React, { useEffect, useState } from 'react'
import { useAPI } from '../Context/MyContext'
import { fontSize } from '@mui/system';

function CreditBadge() {
    const { getCredits } = useAPI()
    const [creadits, setCredits] = useState(0)

    useEffect(() => {
        async function fetchCredits() {
            try {
                const res = await getCredits();
                // console.log("Credits Data:", res);
                setCredits(res.credits);
            } catch (error) {
                console.error("Error fetching credits:", error);
            }
        }
        fetchCredits();
    }, []);
    // console.log("Creadits:", creadits);
    return (
        <>
            {/* <div className="mb-4 text-sm text-gray-700 flex items-center gap-2">
                <span className='text-md font-semibold text-[#333] mb-2'>Available Credits:</span>

                <span
                    className="px-4 py-1 rounded-full text-sm font-semibold
                   bg-yellow-200 shadow-md border border-yellow-500
                   flex items-center gap-2"
                >
                   
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        className="w-5 h-5 text-yellow-700"
                    >
                        <path d="M12 2C6.49 2 2 5.58 2 10s4.49 8 10 8 10-3.58 10-8-4.49-8-10-8zm0 14c-4.07 0-7-2.69-7-6s2.93-6 7-6 7 2.69 7 6-2.93 6-7 6z" />
                    </svg>

                    {creadits || 0}
                </span>
            </div> */}

<div className="mb-4 flex items-center gap-3">
    <span className="text-base font-semibold text-gray-700" 
     style={{fontSize:"20px"}}
      >
        Credits:
    </span>

    <span
        className="px-4 py-1 rounded-full text-base font-semibold
                   bg-yellow-300 border border-yellow-500 shadow
                   flex items-center gap-2"
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-5 h-5 text-yellow-800"
        >
            <path d="M12 2C6.49 2 2 5.58 2 10s4.49 8 10 8 10-3.58 10-8-4.49-8-10-8zm0 14c-4.07 0-7-2.69-7-6s2.93-6 7-6 7 2.69 7 6-2.93 6-7 6z" />
        </svg>

        {creadits || 0}
    </span>
</div>

        </>

    )
}

export default CreditBadge